var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-lg-8 col-xl-9"},[(_vm.showLoading)?_c('Loading'):_vm._e(),_vm._v(" "),(_vm.errorMessage !== '')?_c('section',{staticClass:"col-12 col-lg-8 col-xl-9"},[_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_vm._v("\n      "+_vm._s(_vm.errorMessage)+"\n    ")])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d5a0f96","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PreContentHeader.vue
// module id = null
// module chunks = 